/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TargetedIcon = ({ width = 24, height = 24, hidden = false, title = 'Targeted' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.225 15.281 12 10.056V6.847a2 2 0 0 0-.586-1.415L6.854.239A.5.5 0 0 0 6 .592L4.5 4.5.6 6.018a.5.5 0 0 0-.354.854l5.173 4.56A1.98 1.98 0 0 0 6.828 12h3.173l5.262 5.251a.693.693 0 0 0 .981 0l.981-.981a.693.693 0 0 0 0-.989ZM19.328 14.243a3.057 3.057 0 0 1-.449 3.7l-.982.982a3.052 3.052 0 0 1-3.611.543 3.994 3.994 0 1 0 5.042-5.223Z"
    />
    <path
      d="M18 2.1a15.824 15.824 0 0 0-5.5 1l.675.781A4.343 4.343 0 0 1 14.379 6.9v1.659a10.24 10.24 0 1 1-5.833 5.863H6.855A4.339 4.339 0 0 1 3.827 13.2l-.747-.658A15.891 15.891 0 1 0 18 2.1Z"
    />
  </svg>`;
};
